import AllInclusiveIcon from "@mui/icons-material/AllInclusive";
import { IconButton, Text } from "designSystem/index";
import React from "react";
import CssColumnGrid from "../../CssColumnGrid";

export default () => {
	return (
		<CssColumnGrid columns={2}>
			<Text semiBold text="localized" />
			<Text semiBold text="not localized" />
			<IconButton 
				res="Resource" 
				resParams={["Icon"]} 
				size="large" 
				tooltipProps={{
					placement: "right",
				}}
			>
				<AllInclusiveIcon />
			</IconButton>
			<IconButton 
				size="large"
				title="Not localized"
				tooltipProps={{
					placement: "right",
				}}
			>
				<AllInclusiveIcon />
			</IconButton>
		</CssColumnGrid>
	);
};